import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { search } from '@primeicons/core/search';

@Component({
    selector: 'svg[data-p-icon="search"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class Search extends CoreIcon {
    constructor() {
        super();
        this._icon = search;
    }
}
